import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { MeasureTableModel } from '../model/measure-table.model';

@Injectable()
export class MeasureTableService {

    path = '/measure-tables';

    constructor(private baseService: BaseService) { }

    getPaginated(init: number, end: number, q?: string) {
        const params: any = { init, end, origin: 'manual' };
        if (q) params.q = q;
        return this.baseService.get(this.path, '', params);
    }

    getById(id: number) {
        return this.baseService.get(this.path, '/' + id, {});
    }

    post(model: MeasureTableModel) {
        return this.baseService.post(this.path, '/', model);
    }

    private resolveId(model: any): number {
        return model.id || model.measure_table_id;
    }

    put(model: any) {
        const id = this.resolveId(model);
        return this.baseService.put(this.path, '/' + id, model);
    }

    save(model: any) {
        return this.resolveId(model) ? this.put(model) : this.post(model);
    }

    duplicate(id: number) {
        return this.baseService.post(this.path, '/' + id + '/duplicate', {});
    }

    delete(id: number) {
        return this.baseService.delete(this.path, '/' + id);
    }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/measure-table.service.ts